var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"bg-light position-relative"},[_c('router-view',{staticClass:"vh-100"}),_c('b-navbar-nav',{staticClass:"position-absolute top-0 end-0 me-3 mt-3"},[_c('langusge-switcher')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }